<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div mat-dialog-content>
  <app-card-contrato *ngIf="!isFalsy(contratoDetailDto)" [contratoDetailDto]="contratoDetailDto">
  </app-card-contrato>
</div>
